export enum ConstraintEnum {
    SHIPPER_ATTN_EMPTY = 'SHIPPER_ATTN_EMPTY',
    SHIPPER_ORGANIZATION_EMPTY = 'SHIPPER_ORGANIZATION_EMPTY',
    SHIPPER_STREET1_EMPTY = 'SHIPPER_STREET1_EMPTY',
    SHIPPER_STREET1_LENGTH = 'SHIPPER_STREET1_LENGTH',
    SHIPPER_STREET2_LENGTH = 'SHIPPER_STREET2_LENGTH',
    SHIPPER_TELEPHONE_EMPTY = 'SHIPPER_TELEPHONE_EMPTY',
    SHIPPER_EMAIL_EMPTY = 'SHIPPER_EMAIL_EMPTY',
    SHIPPER_EMAIL_INVALID = 'SHIPPER_EMAIL_INVALID',
    SHIPPER_EMAIL_LENGTH = 'SHIPPER_EMAIL_LENGTH',
    SHIPPER_TELEPHONE_DUPLICATE = 'SHIPPER_TELEPHONE_DUPLICATE',
    SHIPPER_TELEPHONE_FORMAT = 'SHIPPER_TELEPHONE_FORMAT',
    SHIPPER_CITY_EMPTY = 'SHIPPER_CITY_EMPTY',
    SHIPPER_CITY_LENGTH = 'SHIPPER_CITY_LENGTH',
    SHIPPER_POSTALCODE_EMPTY = 'SHIPPER_POSTALCODE_EMPTY',
    SHIPPER_POSTALCODE_FORMAT = 'SHIPPER_POSTALCODE_FORMAT',
    SHIPPER_COUNTRY_EMPTY = 'SHIPPER_COUNTRY_EMPTY',
    SHIPPER_COUNTRY_INVALID = 'SHIPPER_COUNTRY_INVALID',
    SHIPPER_PROVINCE_INVALID = 'SHIPPER_PROVINCE_INVALID',

    BROKER_COUNTRY_INVALID = 'BROKER_COUNTRY_INVALID',
    BROKER_COUNTRY_EMPTY = 'BROKER_COUNTRY_EMPTY',
    BROKER_POSTALCODE_FORMAT = 'BROKER_POSTALCODE_FORMAT',

    SOLD_TO_COUNTRY_INVALID = 'SOLD_TO_COUNTRY_INVALID',
    SOLD_TO_COUNTRY_EMPTY = 'SOLD_TO_COUNTRY_EMPTY',
    SOLD_TO_POSTALCODE_FORMAT = 'SOLD_TO_POSTALCODE_FORMAT',

    DESTINATION_ATTN_EMPTY = 'DESTINATION_ATTN_EMPTY',
    DESTINATION_ORGANIZATION_EMPTY = 'DESTINATION_ORGANIZATION_EMPTY',
    DESTINATION_STREET1_EMPTY = 'DESTINATION_STREET1_EMPTY',
    DESTINATION_STREET1_LENGTH = 'DESTINATION_STREET1_LENGTH',
    DESTINATION_STREET2_LENGTH = 'DESTINATION_STREET2_LENGTH',
    DESTINATION_TELEPHONE_EMPTY = 'DESTINATION_TELEPHONE_EMPTY',
    DESTINATION_EMAIL_EMPTY = 'DESTINATION_EMAIL_EMPTY',
    DESTINATION_EMAIL_INVALID = 'DESTINATION_EMAIL_INVALID',
    DESTINATION_EMAIL_LENGTH = 'DESTINATION_EMAIL_LENGTH',
    DESTINATION_TELEPHONE_DUPLICATE = 'DESTINATION_TELEPHONE_DUPLICATE',
    DESTINATION_TELEPHONE_FORMAT = 'DESTINATION_TELEPHONE_FORMAT',
    DESTINATION_CITY_EMPTY = 'DESTINATION_CITY_EMPTY',
    DESTINATION_CITY_LENGTH = 'DESTINATION_CITY_LENGTH',
    DESTINATION_POSTALCODE_EMPTY = 'DESTINATION_POSTALCODE_EMPTY',
    DESTINATION_POSTALCODE_FORMAT = 'DESTINATION_POSTALCODE_FORMAT',
    DESTINATION_COUNTRY_EMPTY = 'DESTINATION_COUNTRY_EMPTY',
    DESTINATION_COUNTRY_INVALID = 'DESTINATION_COUNTRY_INVALID',
    DESTINATION_PROVINCE_INVALID = 'DESTINATION_PROVINCE_INVALID',

    PACKAGE_WEIGHT_ZERO = 'PACKAGE_WEIGHT_ZERO',
    SHIPMENT_DATE_PAST = 'SHIPMENT_DATE_PAST',

    NO_COMMODITIES = 'NO_COMMODITIES',
    NO_PACKAGES = 'NO_PACKAGES',

    INSURANCE_CATEGORY_DISABLED = 'INSURANCE_CATEGORY_DISABLED',
    INSURANCE_ABOVE_LIMIT = 'INSURANCE_ABOVE_LIMIT'

}
